import React from 'react';
import { useSelector } from 'react-redux';
import { languageSwitch } from '../../dictionary/translateFunctions';
import { conMiniaturas } from '../../conexiones/varConexiones';
import './miniatura.css';
const Miniatura = (props) => {
    const lang = useSelector((state) => state.lang.lang);
    const screen = window.screen.width;
    const img_prima = conMiniaturas+props.proy+'/thum_'+props.imagen;
    const img = img_prima.replace(/\s/g,"%20");

    return(
        <div className='miniatura'
            onClick={()=>{props.action({type:'proy',on:true,id:props.proy,cat:props.categoria,scroll:false})}}>
            <div className='miniatura-main'>
                <div className='miniatura-img' style={{backgroundImage : `linear-gradient(to bottom, rgba(255, 0, 150, 0), rgba(20, 20, 20, 0.5)), url("${img}")`,backgroundPosition:'center', backgroundSize:'cover'}}></div>
            <div className='miniatura-desc' data-elem="miniatura-wimg">
                <p className="seccion_descripcion">{props.año === null || props.año === '0' ? '':props.año}</p>
                {screen > 500 ? <h4>{languageSwitch(props.titulo,lang)}</h4>:<h5>{languageSwitch(props.titulo,lang)}</h5>}
                <p className="seccion_descripcion">{props.cliente}</p>
            </div>
            </div>
        </div>
    )
}

export default Miniatura;